import { CAPACITY_WAITLIST } from '../../constants';
import { CheckoutState } from '../../state';
import { getNamespaceValue } from '../utils/selector';
import { getIsWaitlistAvailable } from './pureSelectors';

/**
 * @note On its own, does not necessarily mean the waitlist *should* be shown as
 * this method does not check each ticket's status.
 *
 * @return `true` when waitlist is enabled, available for new entries and it's using a specific ticket as trigger.
 */
export const getHasTicketLevelWaitlist = (state: CheckoutState) =>
    getIsWaitlistAvailable(state) &&
    getNamespaceValue(state.event, 'waitlistSettings.ticketId') !==
        CAPACITY_WAITLIST;
